// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedProviderCompany: null,
  availableUsers: []
}

const providerCompany = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_PROVIDERS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_JOB':
      return { ...state }
    case 'DELETE_JOB':
      return { ...state }
    case 'ADD_USER_COMPANY':
      return { ...state }
    case 'DELETE_USER_COMPANY':
      return { ...state }
    case 'GET_PROVIDER_COMPANY':
      return { ...state, selectedProviderCompany: action.selectedProviderCompany }
    case 'EDIT_JOB':
      return { ...state }
    case 'GET_AVAILABLE_USERS':
      return { ...state, availableUsers: action.availableUsers }
    default:
      return { ...state }
  }
}
export default providerCompany
